/**
 * @generated SignedSource<<2906c902eef4cae40baca2690193190d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useWorkspaceSignalEditRemoveImagesMutation$variables = {
  imageIds: ReadonlyArray<string>;
  signalWorkspaceId: string;
};
export type useWorkspaceSignalEditRemoveImagesMutation$data = {
  readonly signalWorkspace: {
    readonly removeImages: {
      readonly descriptionImages: ReadonlyArray<{
        readonly id: string;
      }>;
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"WorkspaceSignalEditMainEditedInfo_Signal">;
    };
  };
};
export type useWorkspaceSignalEditRemoveImagesMutation = {
  response: useWorkspaceSignalEditRemoveImagesMutation$data;
  variables: useWorkspaceSignalEditRemoveImagesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "imageIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "signalWorkspaceId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "signalWorkspaceId"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "imageIds",
    "variableName": "imageIds"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "descriptionImages",
  "plural": true,
  "selections": [
    (v4/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useWorkspaceSignalEditRemoveImagesMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "SignalWorkspaceMutation",
        "kind": "LinkedField",
        "name": "signalWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "SignalWorkspace",
            "kind": "LinkedField",
            "name": "removeImages",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WorkspaceSignalEditMainEditedInfo_Signal"
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useWorkspaceSignalEditRemoveImagesMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "SignalWorkspaceMutation",
        "kind": "LinkedField",
        "name": "signalWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "SignalWorkspace",
            "kind": "LinkedField",
            "name": "removeImages",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "updatedBy",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UnzonedDate",
                "kind": "LinkedField",
                "name": "updatedAtDate",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isoString",
                        "storageKey": null
                      }
                    ],
                    "type": "Date",
                    "abstractKey": "__isDate"
                  }
                ],
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5b324d19d6d9e6d816d7c54a9e22f65e",
    "id": null,
    "metadata": {},
    "name": "useWorkspaceSignalEditRemoveImagesMutation",
    "operationKind": "mutation",
    "text": "mutation useWorkspaceSignalEditRemoveImagesMutation(\n  $signalWorkspaceId: ID!\n  $imageIds: [ID!]!\n) {\n  signalWorkspace(id: $signalWorkspaceId) {\n    removeImages(imageIds: $imageIds) {\n      id\n      ...WorkspaceSignalEditMainEditedInfo_Signal\n      descriptionImages {\n        id\n      }\n    }\n  }\n}\n\nfragment FormattedDate on Date {\n  __isDate: __typename\n  ...useFormattedDate\n}\n\nfragment WorkspaceSignalEditMainEditedInfo_Signal on SignalWorkspace {\n  updatedBy {\n    id\n    name\n  }\n  updatedAtDate {\n    ...FormattedDate\n  }\n}\n\nfragment useFormattedDate on Date {\n  __isDate: __typename\n  isoString\n}\n"
  }
};
})();

(node as any).hash = "a50a33adc41f353b7f4268f6527e8d7b";

export default node;
